/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
import { tickBoxClassName } from './styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { transition } from '../styles';
import { B200 } from '@atlaskit/theme/colors';
var getSelectedStyles = function getSelectedStyles(selected) {
  return selected ? "background-color: ".concat("var(--ds-icon-information, ".concat(B200, ")"), ";\n      color: ", "var(--ds-icon-inverse, white)", ";") : "";
};
var oldWrapperStyes = css({
  width: '14px',
  height: '14px',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  span: {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
      height: '14px'
    }
  }
});
var wrapperStyles = function wrapperStyles(selected) {
  return css(
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  transition && transition(), {
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    width: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-200, 16px)",
    position: 'absolute',
    top: "var(--ds-space-075, 7px)",
    left: "var(--ds-space-075, 7px)",
    borderRadius: "var(--ds-space-250, 20px)",
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
      display: 'block'
    },
    display: 'grid',
    placeItems: 'center'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  getSelectedStyles(selected));
};
wrapperStyles.displayName = 'TickBoxWrapper';
export var TickBoxWrapper = function TickBoxWrapper(props) {
  return jsx("div", {
    id: "tickBoxWrapper",
    css: [
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    wrapperStyles(props.selected), !fg('platform-visual-refresh-icons') && oldWrapperStyes]
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: tickBoxClassName
  }, props.children);
};